export default {
  title: "Importador"
  , form: {
    id: { th: "ID" }
    , fecha: { th: "Fecha" }
    , estatus: { th: "Estado" }
    , subtipo: { th: "Tipo" }
    , nombre: { th: "Nombre del Archivo" }
    , registros: { th: "Registros" }
    , usuarioalta: { th: "Usuario" }
  }
  , detalle: {
    nombre: "Nombre del Archivo"
    , fecha: "Fecha"
    , subtipo: "Tipo"
    , id: "ID"
    , total: "Total registros validados"
    , totalError: "Registros inválidos"
    , totalOk: "Registros validos"
    , totalInsert: "Registros dados de alta"
    , totalUpdate: "Registros actualizados"
    , duration: "Duración del proceso"
  }
  , buttons: {
    log: "Descargar Errores"
    , retry: "Reenviar"
  }
  , filters: {
    subtipo: "Tipo"
    , estatus: "Estado"
    , fecha: "Fecha"
    , username: "Usuario"
    , mailsent: "Enviado a Email"
  }
  , errors: {
    BD7000: { text: "Ocurrió un error en el módulo de importación" }
    , WS7000: { text: "Ocurrió un error en el módulo de importación" }
    , JS7000: { text: "Ocurrió un error en el módulo de importación" }
    , CR7000: { text: "Ocurrió un error en el módulo de importación" }
    , VL0000: { text: "El nombre del archivo debe corresponder al catálogo que se importará" }
    , DP7000: { text: "El archivo ya fue subido y validado previamente" }
    , TP7000: { text: "El archivo no pertenece a ningun tipo/subtipo de archivo valido" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/filetransaction/importer.js